'use client'

import { SectionHeader } from '@/ui/section-header'
import { TaskChecklist } from '@/entries'
import type { ChecklistItem } from '@/entries'

interface FormChecklistSectionProps {
  checklistItems: ChecklistItem[] | null
  onToggle: (id: string, checked: boolean) => void
  isLoading: boolean
}

/**
 * Task checklist display for the capture form.
 */
export function FormChecklistSection({
  checklistItems,
  onToggle,
  isLoading,
}: FormChecklistSectionProps) {
  if (!checklistItems || checklistItems.length === 0) return null

  return (
    <div className="bg-muted/30 border-border/40 rounded-lg border p-3 sm:p-4">
      <SectionHeader>Checklist</SectionHeader>
      <TaskChecklist
        items={checklistItems}
        onToggle={onToggle}
        disabled={isLoading}
      />
    </div>
  )
}
